<template>
<!--侧边导航-->
  <div class="outBox">
    <router-link to="/orders">
      <div class="innerImg">
        <img src="../assets/order/logo@2x.png" alt="">
      </div>
    </router-link>
    <div class="menuList">
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo changeHover"
        background-color="#000000"
        text-color="#fff"
        v-for="(item,indexs) in menuList" :key="indexs"
        active-text-color="#fff"
        @select="changeItem"
      >
        <el-menu-item :index="item.path"  :class="activeMenu == item.path ? 'orange':''">
                    <img :src="item.icon" alt="">
          <span slot="title">
            {{item.name}}
           <div class="pop" v-if="item.name == 'Redemption' && preNum && preNum<= 99"  :class="activeMenu == item.path ? 'changePop':''">{{preNum}}</div>
           <div class="pop" v-if="item.name == 'Redemption' && preNum>99" style="line-height: 22px"  :class="activeMenu == item.path ? 'changePop':''">...</div>
          </span>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import {getRedemptionRequestCount} from "@/api/redemption";
import { EventBus } from '@/api/eventBus';

export default {
  data(){
    return{
      oneArrow:false,
      twoArrow:false,
      menuList:[
        {name:"Orders",icon:require('../assets/order/Dashboard@2x.png'),path:'/orders'},
        {name:"Zip code & Area",icon:require('../assets/order/zipcode@2x.png'),path:'/zipCode'},
        {name:"Pricing",icon:require('../assets/order/pricing@2x.png'),path:'/pricing'},
        {name:"Drivers",icon:require('../assets/order/driver@2x.png'),path:'/drivers'},
        {name:"Customers",icon:require('../assets/order/Customer@2x.png'),path:'/customers'},
        {name:"Coupons",icon:require('../assets/order/Coupon@2x.png'),path:'/coupons'},
        {name:"ADs",icon:require('../assets/order/ads@2x.png'),path:'/ads'},
        {name:"Redemption",icon:require('../assets/order/gift@2x.png'),path:'/redemption'},
        {name:"Earnings Review ",icon:require('../assets/order/dollar@2x.png'),path:'/wage'},
      ],
      activeMenu:'/index',
      addNewTaskDiog:false,
      title:'Create a New Task',
      showSelect:false,
      options1:[],
      options2:[],
      value1:"",
      value2:"",
      preNum:'',
      dispatch_num:'',
      pollTimeout:''
    }
  },
  created() {
    this.longPoll()
    EventBus.$on('updateNum', (message) => {
     getRedemptionRequestCount().then(res=>{
       console.log(res,'ddd')
       this.preNum = res.data.count; // 收集新消息
     }); // 请求长轮询接口
    });
  },
  beforeDestroy() {
    // 清除定时器
    if (this.pollTimeout) {
      clearTimeout(this.pollTimeout);
    }
  },
  mounted() {
  },
  methods:{
    changeItem(index){
      console.log(index,'dd')
        this.activeMenu = index
        this.$router.push(index)
      // }
    },
    async longPoll() {
      try {
        const response = await getRedemptionRequestCount(); // 请求长轮询接口
        const data = await response;
        this.preNum = data.data.count; // 收集新消息

        // 设置定时器，每隔 5 秒调用一次 longPoll
        this.pollTimeout = setTimeout(() => {
          this.longPoll(); // 再次发起长轮询请求
        }, 5000 * 60); // 5000 毫秒 = 5 秒

      } catch (error) {
        console.error('Polling error:', error);
        this.pollTimeout = setTimeout(this.longPoll, 5000 * 60); // 请求失败时重试
      }
    }
  },
  watch: {
    '$route': {
      handler(to) {
        const path = this.menuList.find(item => item.path === to.path)?.path
        if (path) {
          this.activeMenu = path
        }
      },
      deep: true
    }
  },
}
</script>

<style scoped lang="less">
.changePosition{
  margin-top: 0px!important;
}
.outSelect{
  display: flex;
  position: absolute;
  top: 35px;
  left: 180px;
  .rightSelete{
    display: flex;
  }
  .leftSelect{
    display: flex;
    line-height: 32px;
    margin-left: 24px;
    font-weight: bold;
    div{
      cursor: pointer;
    }
    .innerLeft{
      margin-right: 16px;
    }
  }

}
.outBox{
  padding: 24px 16px;
  color: #FFFFFF;
  /deep/ .el-dialog__header{
    padding: 32px 32px 0px 32px;
  }
  .innerImg{
    cursor: pointer;
    img{
      width: 68px;
    }
  }
  .addNew{
    width: 168px;
    height: 32px;
    font-size: 14px;
    border-radius: 16px;
    border: 1px solid #FFFFFF;
    line-height: 32px;
    margin: 24px 0 20px;
    cursor: pointer;
  }
  .addNew:hover{
    width: 168px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 16px;
    line-height: 32px;
    margin: 24px 0 20px;
    cursor: pointer;
    color: #1F2D42;
  }
  .menuList{
    font-size: 14px;
    font-weight: bold;
    .pop{
      display: inline-block;
      background-color: #FFFFFF;
      width: 28px;
      height: 28px;
      line-height: 29px;
      text-align: center;
      border-radius: 50%;
      color: #1F2D42;
      transform: translateY(-3px);
    }
    ul{
      text-align: left;
      li{
        text-align: left;
        cursor: pointer;
        margin: 10px 0;
        img{
          width: 24px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
  }
  .el-menu{
    border-right: none !important;
  }
  .el-menu-item{
    height: 40px;
    line-height: 40px;
  }
  .el-menu-item:hover{
    background-color: #E95646!important;
    border-radius: 8px;
  }
  li.el-menu-item {
    border-radius: 8px;
  }
  .orange{
    background-color: #E95646!important;
    border-radius: 8px;
  }
.changePop{
  color: #E95646!important;
}
  .changes{
    border-radius: 16px;
    border: 1px solid #FFFFFF;
    background: #1F2D42;
  }
  .changes:hover{
    color: #1F2D42;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #FFFFFF;
  }
}
</style>
